import { render, staticRenderFns } from "./OrderStatusManager.vue?vue&type=template&id=b9617242"
import script from "./OrderStatusManager.vue?vue&type=script&lang=js"
export * from "./OrderStatusManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports